import * as i0 from '@angular/core';
import { PLATFORM_ID, Component, Inject, Input, Output, ContentChildren, NgModule } from '@angular/core';
import DxActionSheet from 'devextreme/ui/action_sheet';
import * as i1 from 'devextreme-angular/core';
import { DxComponent, DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper, DxIntegrationModule, DxTemplateModule } from 'devextreme-angular/core';
import { DxiItemComponent, DxiItemModule } from 'devextreme-angular/ui/nested';

/*!
 * devextreme-angular
 * Version: 24.1.7
 * Build date: Wed Oct 30 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-angular
 */
/* tslint:disable:max-line-length */
/**
 * The ActionSheet UI component is a sheet containing a set of buttons located one under the other. These buttons usually represent several choices relating to a single task.

 */
let DxActionSheetComponent = /*#__PURE__*/(() => {
  class DxActionSheetComponent extends DxComponent {
    _watcherHelper;
    _idh;
    instance = null;
    /**
     * The text displayed in the button that closes the action sheet.
    
     */
    get cancelText() {
      return this._getOption('cancelText');
    }
    set cancelText(value) {
      this._setOption('cancelText', value);
    }
    /**
     * Binds the UI component to data.
    
     */
    get dataSource() {
      return this._getOption('dataSource');
    }
    set dataSource(value) {
      this._setOption('dataSource', value);
    }
    /**
     * Specifies whether the UI component responds to user interaction.
    
     */
    get disabled() {
      return this._getOption('disabled');
    }
    set disabled(value) {
      this._setOption('disabled', value);
    }
    /**
     * Specifies the global attributes to be attached to the UI component&apos;s container element.
    
     */
    get elementAttr() {
      return this._getOption('elementAttr');
    }
    set elementAttr(value) {
      this._setOption('elementAttr', value);
    }
    /**
     * Specifies the UI component&apos;s height.
    
     */
    get height() {
      return this._getOption('height');
    }
    set height(value) {
      this._setOption('height', value);
    }
    /**
     * Specifies text for a hint that appears when a user pauses on the UI component.
    
     */
    get hint() {
      return this._getOption('hint');
    }
    set hint(value) {
      this._setOption('hint', value);
    }
    /**
     * Specifies whether the UI component changes its state when a user pauses on it.
    
     */
    get hoverStateEnabled() {
      return this._getOption('hoverStateEnabled');
    }
    set hoverStateEnabled(value) {
      this._setOption('hoverStateEnabled', value);
    }
    /**
     * The time period in milliseconds before the onItemHold event is raised.
    
     */
    get itemHoldTimeout() {
      return this._getOption('itemHoldTimeout');
    }
    set itemHoldTimeout(value) {
      this._setOption('itemHoldTimeout', value);
    }
    /**
     * An array of items displayed by the UI component.
    
     */
    get items() {
      return this._getOption('items');
    }
    set items(value) {
      this._setOption('items', value);
    }
    /**
     * Specifies a custom template for items.
    
     */
    get itemTemplate() {
      return this._getOption('itemTemplate');
    }
    set itemTemplate(value) {
      this._setOption('itemTemplate', value);
    }
    /**
     * Switches the UI component to a right-to-left representation.
    
     */
    get rtlEnabled() {
      return this._getOption('rtlEnabled');
    }
    set rtlEnabled(value) {
      this._setOption('rtlEnabled', value);
    }
    /**
     * Specifies whether or not to display the Cancel button in action sheet.
    
     */
    get showCancelButton() {
      return this._getOption('showCancelButton');
    }
    set showCancelButton(value) {
      this._setOption('showCancelButton', value);
    }
    /**
     * A Boolean value specifying whether or not the title of the action sheet is visible.
    
     */
    get showTitle() {
      return this._getOption('showTitle');
    }
    set showTitle(value) {
      this._setOption('showTitle', value);
    }
    /**
     * Specifies the element the action sheet popover points at. Applies only if usePopover is true.
    
     */
    get target() {
      return this._getOption('target');
    }
    set target(value) {
      this._setOption('target', value);
    }
    /**
     * The title of the action sheet.
    
     */
    get title() {
      return this._getOption('title');
    }
    set title(value) {
      this._setOption('title', value);
    }
    /**
     * Specifies whether or not to show the action sheet within a Popover UI component.
    
     */
    get usePopover() {
      return this._getOption('usePopover');
    }
    set usePopover(value) {
      this._setOption('usePopover', value);
    }
    /**
     * A Boolean value specifying whether or not the ActionSheet UI component is visible.
    
     */
    get visible() {
      return this._getOption('visible');
    }
    set visible(value) {
      this._setOption('visible', value);
    }
    /**
     * Specifies the UI component&apos;s width.
    
     */
    get width() {
      return this._getOption('width');
    }
    set width(value) {
      this._setOption('width', value);
    }
    /**
    
     * A function that is executed when the Cancel button is clicked or tapped.
    
    
     */
    onCancelClick;
    /**
    
     * A function that is executed when the UI component is rendered and each time the component is repainted.
    
    
     */
    onContentReady;
    /**
    
     * A function that is executed before the UI component is disposed of.
    
    
     */
    onDisposing;
    /**
    
     * A function used in JavaScript frameworks to save the UI component instance.
    
    
     */
    onInitialized;
    /**
    
     * A function that is executed when a collection item is clicked or tapped.
    
    
     */
    onItemClick;
    /**
    
     * A function that is executed when a collection item is right-clicked or pressed.
    
    
     */
    onItemContextMenu;
    /**
    
     * A function that is executed when a collection item has been held for a specified period.
    
    
     */
    onItemHold;
    /**
    
     * A function that is executed after a collection item is rendered.
    
    
     */
    onItemRendered;
    /**
    
     * A function that is executed after a UI component property is changed.
    
    
     */
    onOptionChanged;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    cancelTextChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    dataSourceChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    disabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    elementAttrChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    heightChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    hintChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    hoverStateEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemHoldTimeoutChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemsChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    itemTemplateChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    rtlEnabledChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showCancelButtonChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    showTitleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    targetChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    titleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    usePopoverChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    visibleChange;
    /**
    
     * This member supports the internal infrastructure and is not intended to be used directly from your code.
    
     */
    widthChange;
    get itemsChildren() {
      return this._getOption('items');
    }
    set itemsChildren(value) {
      this.setChildren('items', value);
    }
    constructor(elementRef, ngZone, templateHost, _watcherHelper, _idh, optionHost, transferState, platformId) {
      super(elementRef, ngZone, templateHost, _watcherHelper, transferState, platformId);
      this._watcherHelper = _watcherHelper;
      this._idh = _idh;
      this._createEventEmitters([{
        subscribe: 'cancelClick',
        emit: 'onCancelClick'
      }, {
        subscribe: 'contentReady',
        emit: 'onContentReady'
      }, {
        subscribe: 'disposing',
        emit: 'onDisposing'
      }, {
        subscribe: 'initialized',
        emit: 'onInitialized'
      }, {
        subscribe: 'itemClick',
        emit: 'onItemClick'
      }, {
        subscribe: 'itemContextMenu',
        emit: 'onItemContextMenu'
      }, {
        subscribe: 'itemHold',
        emit: 'onItemHold'
      }, {
        subscribe: 'itemRendered',
        emit: 'onItemRendered'
      }, {
        subscribe: 'optionChanged',
        emit: 'onOptionChanged'
      }, {
        emit: 'cancelTextChange'
      }, {
        emit: 'dataSourceChange'
      }, {
        emit: 'disabledChange'
      }, {
        emit: 'elementAttrChange'
      }, {
        emit: 'heightChange'
      }, {
        emit: 'hintChange'
      }, {
        emit: 'hoverStateEnabledChange'
      }, {
        emit: 'itemHoldTimeoutChange'
      }, {
        emit: 'itemsChange'
      }, {
        emit: 'itemTemplateChange'
      }, {
        emit: 'rtlEnabledChange'
      }, {
        emit: 'showCancelButtonChange'
      }, {
        emit: 'showTitleChange'
      }, {
        emit: 'targetChange'
      }, {
        emit: 'titleChange'
      }, {
        emit: 'usePopoverChange'
      }, {
        emit: 'visibleChange'
      }, {
        emit: 'widthChange'
      }]);
      this._idh.setHost(this);
      optionHost.setHost(this);
    }
    _createInstance(element, options) {
      return new DxActionSheet(element, options);
    }
    ngOnDestroy() {
      this._destroyWidget();
    }
    ngOnChanges(changes) {
      super.ngOnChanges(changes);
      this.setupChanges('dataSource', changes);
      this.setupChanges('items', changes);
    }
    setupChanges(prop, changes) {
      if (!(prop in this._optionsToUpdate)) {
        this._idh.setup(prop, changes);
      }
    }
    ngDoCheck() {
      this._idh.doCheck('dataSource');
      this._idh.doCheck('items');
      this._watcherHelper.checkWatchers();
      super.ngDoCheck();
      super.clearChangedOptions();
    }
    _setOption(name, value) {
      let isSetup = this._idh.setupSingle(name, value);
      let isChanged = this._idh.getChanges(name, value) !== null;
      if (isSetup || isChanged) {
        super._setOption(name, value);
      }
    }
    /** @nocollapse */
    static ɵfac = function DxActionSheetComponent_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxActionSheetComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.DxTemplateHost), i0.ɵɵdirectiveInject(i1.WatcherHelper), i0.ɵɵdirectiveInject(i1.IterableDifferHelper), i0.ɵɵdirectiveInject(i1.NestedOptionHost), i0.ɵɵdirectiveInject(i0.TransferState), i0.ɵɵdirectiveInject(PLATFORM_ID));
    };
    /** @nocollapse */
    static ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
      type: DxActionSheetComponent,
      selectors: [["dx-action-sheet"]],
      contentQueries: function DxActionSheetComponent_ContentQueries(rf, ctx, dirIndex) {
        if (rf & 1) {
          i0.ɵɵcontentQuery(dirIndex, DxiItemComponent, 4);
        }
        if (rf & 2) {
          let _t;
          i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.itemsChildren = _t);
        }
      },
      inputs: {
        cancelText: "cancelText",
        dataSource: "dataSource",
        disabled: "disabled",
        elementAttr: "elementAttr",
        height: "height",
        hint: "hint",
        hoverStateEnabled: "hoverStateEnabled",
        itemHoldTimeout: "itemHoldTimeout",
        items: "items",
        itemTemplate: "itemTemplate",
        rtlEnabled: "rtlEnabled",
        showCancelButton: "showCancelButton",
        showTitle: "showTitle",
        target: "target",
        title: "title",
        usePopover: "usePopover",
        visible: "visible",
        width: "width"
      },
      outputs: {
        onCancelClick: "onCancelClick",
        onContentReady: "onContentReady",
        onDisposing: "onDisposing",
        onInitialized: "onInitialized",
        onItemClick: "onItemClick",
        onItemContextMenu: "onItemContextMenu",
        onItemHold: "onItemHold",
        onItemRendered: "onItemRendered",
        onOptionChanged: "onOptionChanged",
        cancelTextChange: "cancelTextChange",
        dataSourceChange: "dataSourceChange",
        disabledChange: "disabledChange",
        elementAttrChange: "elementAttrChange",
        heightChange: "heightChange",
        hintChange: "hintChange",
        hoverStateEnabledChange: "hoverStateEnabledChange",
        itemHoldTimeoutChange: "itemHoldTimeoutChange",
        itemsChange: "itemsChange",
        itemTemplateChange: "itemTemplateChange",
        rtlEnabledChange: "rtlEnabledChange",
        showCancelButtonChange: "showCancelButtonChange",
        showTitleChange: "showTitleChange",
        targetChange: "targetChange",
        titleChange: "titleChange",
        usePopoverChange: "usePopoverChange",
        visibleChange: "visibleChange",
        widthChange: "widthChange"
      },
      features: [i0.ɵɵProvidersFeature([DxTemplateHost, WatcherHelper, NestedOptionHost, IterableDifferHelper]), i0.ɵɵInheritDefinitionFeature, i0.ɵɵNgOnChangesFeature],
      decls: 0,
      vars: 0,
      template: function DxActionSheetComponent_Template(rf, ctx) {},
      encapsulation: 2
    });
  }
  return DxActionSheetComponent;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let DxActionSheetModule = /*#__PURE__*/(() => {
  class DxActionSheetModule {
    /** @nocollapse */static ɵfac = function DxActionSheetModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || DxActionSheetModule)();
    };
    /** @nocollapse */
    static ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: DxActionSheetModule
    });
    /** @nocollapse */
    static ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
      imports: [DxiItemModule, DxIntegrationModule, DxTemplateModule, DxiItemModule, DxTemplateModule]
    });
  }
  return DxActionSheetModule;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { DxActionSheetComponent, DxActionSheetModule };
